import axios from 'axios';
import {
  ExternalOrderModel,
  ExternalOrderStateEnum,
} from '../models/ExternalOrderModel';

const API_URL = process.env.REACT_APP_API_URL;
const EXTERNAL_ORDERS_URL = `${API_URL}/api/external-orders/`;
export const ORDERS_PER_PAGE = 20;

interface ListExternalOrdersProps {
  page?: number;
  date__gte?: string;
  date__lte?: string;
  status?: ExternalOrderStateEnum;
  number?: string;
}

interface ExternalOrderListResponse {
  count: number;
  next: string;
  previous: string;
  results: Array<ExternalOrderModel>;
}

export function listExternalOrders({
  page = 1,
  date__gte,
  date__lte,
  status,
  number,
}: ListExternalOrdersProps): Promise<{ data: ExternalOrderListResponse }> {
  const limit = ORDERS_PER_PAGE;
  const offset = (page - 1) * limit;
  return axios.get(EXTERNAL_ORDERS_URL, {
    params: { limit, offset, date__gte, date__lte, status, number },
  });
}

export enum BulkActionsEnum {
  PREPARE_ORDERS = 'prepare_orders',
  CANCEL_ORDERS = 'cancel_orders',
}

interface BulkActionProps {
  orders: Array<number>;
  action: BulkActionsEnum;
  date__gte?: string;
  date__lte?: string;
  status?: ExternalOrderStateEnum;
  number?: string;
}

export function performBulkAction({
  orders,
  action,
  date__gte,
  date__lte,
  status,
  number,
}: BulkActionProps) {
  const endpoint = `${EXTERNAL_ORDERS_URL}massive-actions/`;
  return axios.post(endpoint, {
    action,
    orders,
    date__gte,
    date__lte,
    status,
    number,
  });
}
